import { mapGetters } from 'vuex'
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { formatDisplayNumber } from '@/utils/number'
import { formatDisplayDate } from '@/utils/date'

export const listVesMixin = {
  data() {
    return {
      apiUrl: undefined,
      totalItems: 0
    }
  },
  computed: {
    ...mapGetters([
      'checkAccess'
    ]),
    listHeaders() {
      let result = []
      for (const selectedColumn of this.selectedColumns) {
        let findCol = this.columns.find(a => selectedColumn === a.value)
        if (findCol) {
          result.push(findCol)
        }
      }
      result.push(TableConst.tableActionHeader)
      return result
    }
  },
  watch: {
    // For pagination, we dont want to watch all the pagination property using deep (shown in vuetify eg)
    // This way the application will load multiple times at the start (when setting totalElements etc)
    'pagination.descending': function (value) {
      this.fetchData(false)
    },
    'pagination.page': function (value) {
      this.fetchData(false)
    },
    'pagination.rowsPerPage': function (value) {
      this.fetchData(false)
    },
    'pagination.sortBy': function (value) {
      this.fetchData(false)
    }
  },
  methods: {
    formatNumber(xNum) {
      return formatDisplayNumber(xNum)
    },
    formatDate(xDate) {
      return formatDisplayDate(xDate)
    }
  },
  mounted() {
    this.fetchData(true)
  },
  mixins: [
    TableConst.default,
    MessageMixin
  ]
}
